import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { label: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    window.scrollTo(0, 0)
    document.querySelectorAll(".show-products-count").forEach(element => {
      element.textContent = this.labelValue
      element.classList.remove("hidden")
    })
    document.querySelectorAll(".show-products-loading").forEach(element => element.classList.add("hidden"))
    this.element.remove()
  }
}
